import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {validateAnswerHasValue} from '../Utilities';
import {AUformGroup, AUlabel} from "@gov.au/form";
import AUtextInput from "@gov.au/text-inputs";

class AutoComplete extends Component {

    constructor(props) {
        super(props);

        let answer = {
                value: '',
                key: ''
            },
            componentProps = {
                filteredSuggestions: [],
                activeSuggestion: 0,
                showSuggestions: false,
                userEnteredValue: ''
            },
            errorMessage = null;

        if (props.existingAnswer) {
            answer = props.existingAnswer;
        }

        if (props.mandatory) {
            errorMessage = validateAnswerHasValue(props.type, answer, props.mandatory);
        }

        this.state = {
            answer: answer,
            componentProps: componentProps,
            errorMessage: errorMessage
        };
    }

    /** This method is triggered when the user changes the value in the input field
     *
     * @param event
     */
    changeEvent = (event) => {
        let userInput = event.currentTarget.value.trim(),
            answer = {value: userInput},
            errorMessage = null,
            filteredSuggestions = [],
            showSuggestions = true;

        filteredSuggestions = this.props.suggestions.filter(
            suggestion =>
                suggestion.value.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        if (filteredSuggestions.length === 1 && filteredSuggestions[0].value.toLowerCase() === userInput.toLowerCase()) {
            showSuggestions = false;
        } else {
            if (userInput) {
                errorMessage = this.props.noSuggestionErrorMessage;
            } else {
                errorMessage = validateAnswerHasValue(this.props.type, answer, this.props.mandatory);
            }
        }

        answer = {
            value: (filteredSuggestions.length === 1 && filteredSuggestions[0].value.toLowerCase() === userInput.toLowerCase()) ? filteredSuggestions[0].value : '',
            key: (filteredSuggestions.length === 1 && filteredSuggestions[0].value.toLowerCase() === userInput.toLowerCase()) ? filteredSuggestions[0].key : ''
        };
        let componentProps = {
            userEnteredValue: event.currentTarget.value,
            filteredSuggestions: filteredSuggestions,
            showSuggestions: showSuggestions,
            activeSuggestion: -1
        }
        this.setState({
            answer: answer,
            componentProps: componentProps,
            errorMessage: errorMessage
        });

        this.updateProps(answer, errorMessage);
    }

    /** This method is called when the user mouse click on the suggestion
     *
     * @param event
     */
    suggestionClickEvent = (event) => {
        event.preventDefault();
        const {activeSuggestion, filteredSuggestions} = this.state.componentProps;
        let answer = {
                value: filteredSuggestions[activeSuggestion].value,
                key: filteredSuggestions[activeSuggestion].key
            },
            componentProps = {
                ...this.state.componentProps,
                userEnteredValue: event.target.innerText,
                activeSuggestion: 0,
                showSuggestions: false
            },
            errorMessage = null;
        this.setState({
            answer: answer,
            componentProps: componentProps,
            errorMessage: errorMessage
        });
        this.updateProps(answer, errorMessage);
    }

    /** This method is triggered when the user mouse hover on the suggestion.
     *
     * @param event
     */
    suggestionHoverEvent = (event) => {
        this.setState({
            componentProps: {
                ...this.state.componentProps,
                activeSuggestion: parseInt(event.target.getAttribute("aria-posinset")) - 1,
                showSuggestions: true
            }
        });
    }

    /** This method is triggered when the user clicks keys on the keyboard.
     *
     * If the key pressed is the up or a down arrow, activeSuggestion is set correctly to highlight the suggestion in the dropdown
     * If the key pressed is enter, the suggestion value is set to state answer and activeSuggestion is set to -1 and showSuggestions is set to false
     *
     * @param event
     */
    keyDownEvent = (event) => {
        const {activeSuggestion, filteredSuggestions, showSuggestions} = this.state.componentProps;
        if (event.keyCode === 13 && showSuggestions) {
            let answer = {
                    value: filteredSuggestions[activeSuggestion].value,
                    key: filteredSuggestions[activeSuggestion].key
                },
                componentProps = {
                    ...this.state.componentProps,
                    userEnteredValue: filteredSuggestions[activeSuggestion].value,
                    activeSuggestion: 0,
                    showSuggestions: false
                },
                errorMessage = null;
            this.setState({
                answer: answer,
                componentProps: componentProps,
                errorMessage: errorMessage
            });
            this.updateProps(answer, errorMessage);
        }
        // Up arrow key function
        else if (event.keyCode === 38) {
            if (activeSuggestion === 0) {
                return;
            }
            this.setState({
                componentProps: {
                    ...this.state.componentProps,
                    activeSuggestion: activeSuggestion - 1,
                    showSuggestions: true
                }
            });
        }
        // Down arrow keys function
        else if (event.keyCode === 40) {
            if (activeSuggestion + 1 === filteredSuggestions.length) {
                return;
            }
            this.setState({
                componentProps: {
                    ...this.state.componentProps,
                    activeSuggestion: activeSuggestion + 1,
                    showSuggestions: true,
                }
            });
        }
    }

    updateProps = (answer, errorMessage) => {
        let questionObject = {
            stepid: this.props.stepid,
            questionid: this.props.id,
            validate: this.props.validate,
            errorMessage: errorMessage,
            mandatory: this.props.mandatory,
            label: this.props.label,
            answer: answer
        }
        this.props.returnQuestionData(questionObject);
    }

    /** This method generates the suggestion markup by looping through the filtered suggestions
     *  and highlighting the part of suggestion the user entered in the input field
     *
     * @returns {any[]}
     */
    generateSelectionMarkup = () => {
        const {filteredSuggestions, showSuggestions, activeSuggestion, userEnteredValue} = this.state.componentProps;

        let suggestionsMarkup;
        if (showSuggestions && filteredSuggestions.length) {
            suggestionsMarkup = (
                filteredSuggestions.map((suggestion, index) => {
                    let className = "";
                    if (index === activeSuggestion) {
                        className = "suggestion-active";
                    }
                    let pattern = '(' + userEnteredValue.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&") + ')';
                    let suggestionValue = suggestion.value.replace(new RegExp(pattern, 'gi'), '<strong>$1</strong>');
                    return (
                        <li className={`suggestion ${className}`} id={`suggestion-list-${index}`} key={suggestion.key}
                            onClick={(event) => {
                                this.suggestionClickEvent(event)
                            }}
                            onMouseEnter={this.suggestionHoverEvent}
                            dangerouslySetInnerHTML={{__html: suggestionValue}}
                            aria-selected={`${className ? 'true' : 'false'}`}
                            aria-posinset={index + 1}
                            aria-setsize={filteredSuggestions.length}>

                        </li>
                    )
                })
            )
        }
        return suggestionsMarkup;
    }

    /** This method will conditionally set the state of the component,
     *  if the click is on the suggestions after the input blur then suggestionClickEvent method will be triggered,
     *  or the click event happens on any other area, then this method will set the activeSuggestion to -1 and showSuggestions = false
     *
     * @param event
     */
    inputBlurevent = (event) => {
        if (!(event.relatedTarget && event.relatedTarget.classList.contains("suggestions"))) {
            this.setState({
                componentProps: {
                    ...this.state.componentProps,
                    activeSuggestion: -1,
                    showSuggestions: false,
                }
            })
        }
    }

    render() {
        const {showSuggestions, activeSuggestion, userEnteredValue} = this.state.componentProps;
        return (
            <AUformGroup className="auto-complete" status={this.props.getStatus(this.state.errorMessage)}>
                <AUlabel text={this.props.label} htmlFor={`auto-complete-input-${this.props.id}`}/>
                <AUtextInput className="auto-complete-input" id={`auto-complete-input-${this.props.id}`}
                             type='text'
                             block
                             autoComplete="off"
                             aria-describedby={`${this.props.id}-error`}
                             aria-autocomplete="list"
                             aria-activedescendant={`suggestion-list-${activeSuggestion}`}
                             aria-expanded={showSuggestions}
                             aria-owns={`listbox-${this.props.id}`}
                             value={this.state.answer.value? this.state.answer.value : userEnteredValue}
                             placeholder={this.props.placeholderText}
                             onBlur={(event) => this.inputBlurevent(event)}
                             onChange={this.changeEvent}
                             onKeyDown={this.keyDownEvent}/>

                <ul tabIndex="-1" id={`listbox-${this.props.id}`} role="listbox"
                    className={`suggestions ${showSuggestions ? "suggestions-box-show" : ""}`}>
                    {this.generateSelectionMarkup()}
                </ul>
                {this.props.createErrorMessage(this.state.errorMessage)}
            </AUformGroup>
        );
    }
}

AutoComplete.defaultProps = {
    noSuggestionErrorMessage: "No suggestions found"
}


AutoComplete.propTypes = {
    id: PropTypes.string.isRequired,
    stepid: PropTypes.string.isRequired,
    initvalue: PropTypes.string,
    label: PropTypes.string.isRequired,
    placeholderText: PropTypes.string,
    mandatory: PropTypes.bool.isRequired,
    noSuggestionErrorMessage: PropTypes.string,
    type: PropTypes.string.isRequired,
    suggestions: PropTypes.array.isRequired,
    existingAnswer: PropTypes.object,
    getStatus: PropTypes.func,
    validate: PropTypes.func,
    returnQuestionData: PropTypes.func,
    createErrorMessage: PropTypes.func
};

const mapStateToProps = (state) => {
    return {
        smartform: state.smartform
    }
}

export default connect(mapStateToProps)(AutoComplete);